
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M53.21 21.18v-6.6h13.58v6.6M60 1v12.73M94.01 61.86H25.99l-7.16-8.74h82.34l-7.16 8.74zM47.73 31.43l-6.88-9.9h38.3l-6.88 9.9"}}),_c('path',{attrs:{"d":"M75.09 109V95.79c0-6.05 7.07-34.24 7.07-34.24M67.5 109V95.79c0-6.05 8.07-34.24 8.07-34.24M44.91 109V95.79c0-6.05-7.07-34.24-7.07-34.24M52.5 109V95.79c0-6.05-8.07-34.24-8.07-34.24M26.5 53l-16-12.79 5-9.18s88.76-.32 89 0l5 9.18L93.5 53M11 40.21h98M60 62.66V109","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    